import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from "react-router-dom";
import ClaroMenuItemBlock from "../organisms/ClaroMenuItemBlock"
import ClaroImage from "../molecules/ClaroImage"
import { getAppSync, getPaymentServiceConf, getTrackId, setTxDataSuccess } from '../../store/actions';
import { selectPaymentServiceConf, selectPaymentServiceResult, getBundleIdFromUrl } from '../../store/selectors/paymentsSelectors'
import PlansContainer from "../containers/PlansContainer"
import SearsContainer from "../containers/SearsContainer"
import MenuTelcelContainer from "../containers/MenuTelcelContainer"
import PaymentFormClaroSocioContainer from "../containers/PaymentFormClaroSocioContainer"
import * as sdkclaro from '@claro/sdkclaromicrofront';
import { GenericFormContextProvider } from '../../context/genericFormContext';
import LobbyContainer from '../containers/LobbyContainer'
import { getUserInfo, getUserInfoLite } from '../../store/actions';
import FullOfferTelcelContainer from '../containers/FullOfferTelcelContainer'
import { getMessengerService } from '../../store/actions';
import { datadogMonitor } from '../organisms/utils';
import ModalServicesNotWork from '../molecules/ModalServicesNotWork';

const ClaroCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
`
class HomePage extends Component {
  constructor(props) {
    super(props)
    this.getServices = this.getServices.bind(this);

    const urlParam = new URLSearchParams(window.location.search);
    const paramTrack = urlParam.get('hasTracking');

    this.state = {
      paramTrack,
      callServices: false
    }
  }  

  componentDidMount() {
    const { getPaymentServiceConf, getUserInfo, getUserInfoLite, getMessengerService, getAppSync, appSyncValues } = this.props; 
    
    sdkclaro.getInstance().switchGoBackButton(true)
    getUserInfo()
    getUserInfoLite()
    getPaymentServiceConf()
    getMessengerService("MiniAppTelcel", "")
    if (Object.keys(appSyncValues).length === 0) {
      getAppSync();
    }    
    setTimeout(() => {
      this.setState({ callServices: true })
    }, 2500);
  }

  componentDidUpdate(prevProps) {
    const { userInfo, getTrackId, paymentsConfig, appSyncValues, trackId } = this.props;

    if (prevProps.paymentsConfig !== paymentsConfig) {
      if (
        appSyncValues &&
        appSyncValues.banks &&
        appSyncValues.banks[0].properties &&
        appSyncValues.banks[0].toggles &&
        appSyncValues.banks[0].toggles.DD_WEB_PAYMENT_SERVICES_ON &&
        paymentsConfig && 
        paymentsConfig.tagServiceId &&
        paymentsConfig.tagServiceId !== prevProps.paymentsConfig.tagServiceId
      ) {
        const { tagServiceId } = paymentsConfig;
        const sessionReplaySampleRate = 
          appSyncValues.banks[0].properties.DD_WEB_PAYMENT_SERVICES_SESSION_REPLAY_SAMPLE_RATE || 0
        datadogMonitor(tagServiceId, sessionReplaySampleRate);
      }
    }

    if (prevProps.appSyncValues !== appSyncValues) {
      if (
        appSyncValues &&
        appSyncValues.banks &&
        appSyncValues.banks[0].properties &&
        appSyncValues.banks[0].toggles &&
        appSyncValues.banks[0].toggles.DD_WEB_PAYMENT_SERVICES_ON &&
        paymentsConfig && 
        paymentsConfig.tagServiceId
      ) {
        const { tagServiceId } = paymentsConfig;
        const sessionReplaySampleRate = 
          appSyncValues.banks[0].properties.DD_WEB_PAYMENT_SERVICES_SESSION_REPLAY_SAMPLE_RATE || 0
        datadogMonitor(tagServiceId, sessionReplaySampleRate);
      }      
    }

    if (
      prevProps.userInfo !== userInfo && 
      this.state.paramTrack === "true" && 
      !trackId
    ) {
      getTrackId();
    }

    if(prevProps.trackId !== trackId) {
      this.setTrackNative(trackId)
    }
  }

  setTrackNative = (trackId) => {
    const {
      setTxDataSuccess 
    } = this.props
    setTxDataSuccess(trackId)
  }

  getServices() {
    if (!this.props.userInfo) {
      console.log('Reload service getUserInfo')
      this.props.getUserInfo();
    }
    if (Object.keys(this.props.userInfoLite).length === 0) {
      console.log('Reload service getUserInfoLite')
      this.props.getUserInfoLite();
    }
    if (!this.props.messages) {
      console.log('Reload service getMessengerService')
      this.props.getMessengerService("MiniAppTelcel", "");
    }
  }
  
  render(){
    const { 
      paymentsConfig:{mainLogo, services, mainTitle, sdkClaroVersion, isClaroPartner, tagServiceId}, 
        trackId, history, canShowNewOfferTelcel, userInfo, userInfoLite, isContainerTelcel,
        messages, isLoading, isLoadingGetUserInfo, isLoadingGetUserInfoLite,
      } = this.props
    const { callServices } = this.state;

    if (
      (!userInfo || (Object.keys(userInfoLite).length === 0) || !messages) && 
      callServices &&
      isContainerTelcel &&
      !isLoading && 
      !isLoadingGetUserInfo && 
      !isLoadingGetUserInfoLite
    ) {
      return (
        <ModalServicesNotWork 
          getServices={this.getServices} />
      );
    }

    if(services && userInfo && (Object.keys(userInfoLite).length > 0)){
      if( services.length === 1){
        if(services[0].serviceData.info.logicType == "plans"){
          return(<
            PlansContainer
            serviceConfigIndex={0} 
            sdkVersion = {sdkClaroVersion} 
            paymentsConfig = {this.props.paymentsConfig} 
            isClaroPartner = {isClaroPartner}
            tagServiceId = {tagServiceId}
            isContainerTelcel = {isContainerTelcel}
            history = {history}
          />)
        }else if(services[0].serviceData.info.logicType == "sears"){
          return(<
            SearsContainer 
            serviceConfigIndex={0} 
            sdkVersion = {sdkClaroVersion} 
            paymentsConfig = {this.props.paymentsConfig} 
            isClaroPartner = {isClaroPartner}
            tagServiceId = {tagServiceId}
            history= {history}
          />)
        }else{
          return(
            <GenericFormContextProvider>
              <PaymentFormClaroSocioContainer
                serviceConfigIndex={0}
                sdkVersion = {sdkClaroVersion}
                paymentsConfig = {this.props.paymentsConfig}
                isClaroPartner = {isClaroPartner}
                tagServiceId = {tagServiceId}
                isContainerTelcel = {isContainerTelcel}
                history= {history}
              />
            </GenericFormContextProvider>
          )
        }
      } else {
        const multipleMicroAppLogicType = this.props.paymentsConfig.multipleMicroAppLogicType; 
        if( multipleMicroAppLogicType == "menuTelcel" && !canShowNewOfferTelcel){
          return(
            <MenuTelcelContainer 
              serviceConfigIndex={this.props.serviceConfigIndex} 
              sdkVersion = {sdkClaroVersion} 
              paymentsConfig = {this.props.paymentsConfig} 
              isClaroPartner = {isClaroPartner}
              trackId = {trackId}
              tagServiceId = {tagServiceId}
              isContainerTelcel={isContainerTelcel}
            />
          )
        }
        if(canShowNewOfferTelcel && multipleMicroAppLogicType == "menuTelcel" ){
          return(<FullOfferTelcelContainer history= {history} isContainerTelcel={isContainerTelcel} />)
        } else if( multipleMicroAppLogicType == "lobby"){
          return(
            <LobbyContainer 
              sdkVersion = {sdkClaroVersion} 
              paymentsConfig = {this.props.paymentsConfig} 
              isClaroPartner = {isClaroPartner}
              trackId = {trackId}
              tagServiceId = {tagServiceId}
              history= {history}
              isContainerTelcel={isContainerTelcel}
            />
          )
        }else{
          return(
            <div id="rooth">
              <ClaroImage {...mainLogo.data} />
              <div id="index_title">{mainTitle.title}</div>
              <ClaroCards>
                {services.map((service, index) => (
                  <ClaroMenuItemBlock {...service.header} key={index}>
                    <Link 
                      to={{
                        pathname:`/service/${index}`, 
                        state: {sdkClaroVersion: sdkClaroVersion, isClaroPartner: isClaroPartner, paymentsConfig: this.props.paymentsConfig }
                      }}
                    >
                      <strong>
                        {service.title}
                      </strong>
                    </Link>
                  </ClaroMenuItemBlock>
                ))}
              </ClaroCards>
            </div>
          )
        }
      }
    }
    return <></>
  }
}


function mapStateToProps(state) {
  const { payments } = state;
  const paymentsConfig = selectPaymentServiceConf(payments);
  const paymentServiceResult = selectPaymentServiceResult(payments);
  const bundleId = getBundleIdFromUrl(state);
  return {
    paymentsConfig,
    paymentServiceResult,
    trackId: state.payments.trackId,
    userInfo: state.payments.userInfo,
    userInfoLite: state.payments.userInfoLite,
    canShowNewOfferTelcel : payments.canShowNewOfferTelcel,
    isContainerTelcel: (bundleId == "com.telcel.contenedor" || bundleId == "com.telcel.contenedor.uat") ? true : false,
    messages: payments.messages,
    isLoading: payments.isLoading,
    isLoadingGetUserInfo: payments.isLoadingGetUserInfo,
    isLoadingGetUserInfoLite: payments.isLoadingGetUserInfoLite,
    appSyncValues: payments.appSyncValues,
    isLoadingAppSync: payments.isLoadingAppSync
  };
}

function mapDispatchToProps(dispatch) {
    
  return bindActionCreators(
      {
        getPaymentServiceConf,
        setTxDataSuccess,
        getTrackId,
        getUserInfo,
        getUserInfoLite,
        getMessengerService,
        getMessengerService,
        getAppSync,
      },
      dispatch,
    );

}

HomePage = connect (
    mapStateToProps,
    mapDispatchToProps
)(HomePage);


export default HomePage
